import styled from 'styled-components/macro';

import BackButton from '../common/BackButton';

export const ButtonsWrapper = styled.div<{ sizeRatio: number }>`
  display: flex;
  align-items: center;
  & > div {
    padding: 0 ${({ sizeRatio }) => `${sizeRatio * 30}px`};
  }
`;

export const ReceiveTransmissionWrapper = styled.div<{ sizeRatio: number }>`
  font-family: 'Presicav';
  font-size: ${({ sizeRatio }) => `${sizeRatio * 18}px`};
`;

export const TransmittingScreen = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Back = styled(BackButton)`
  cursor: none;
  align-self: flex-end;
  margin: 20px 40px 0 0;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    cursor: pointer;
    align-self: flex-start;
    margin: 40px 0 0 20px;
  `};
`;
